var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['total-icon', `total-icon--${_vm.variant}`, { 'total-icon--biggerIcon': _vm.biggerIcon }]},[_c('div',{staticClass:"total-icon__inner"},[_c('font-awesome-icon',{attrs:{"icon":_vm.icon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }